<ul class="bb-layout__horizontal-nav no-print ml-0">
  <!-- My Account -->
  <li class="bb-layout__horizontal-nav-item" *bbIfEntitlements="permissions.canViewMyAccounts">
    <a class="bb-layout__horizontal-nav-link link-item" routerLink="/my-accounts"
      routerLinkActive="bb-layout__horizontal-nav-link--active-item" #myAccountsRouterLink="routerLinkActive"
      [attr.aria-current]="myAccountsRouterLink.isActive ? 'page' : undefined" role="link">
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@myAccounts.nav.item.description">
        My Accounts
      </span>
    </a>
  </li>
  <!-- Pockets -->
  <li class="bb-layout__horizontal-nav-item" *bbIfEntitlements="permissions.canViewManagePockets">
    <a class="bb-layout__horizontal-nav-link" routerLink="/pockets"
      routerLinkActive="bb-layout__horizontal-nav-link--active-item" #pocketsRouterLink="routerLinkActive"
      [attr.aria-current]="pocketsRouterLink.isActive ? 'page' : undefined" role="link">
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@pockets.nav.item.description"> Pockets </span>
    </a>
  </li>
  <!-- Transfers -->
  <li class="bb-layout__horizontal-nav-item" ngbDropdown display="static" #transfersDropdown="ngbDropdown"
    bbLayoutNavDropdown #transfersNavDropdown="bbLayoutNavDropdown" *bbIfEntitlements="permissions.canViewTransfers">
    <a ngbDropdownToggle class="bb-layout__horizontal-nav-link link-item" href="javascript:;" tabindex="0" [ngClass]="{
        'bb-layout__horizontal-nav-link--expanded': transfersDropdown.isOpen() || transfersNavDropdown.isActive
      }" [attr.aria-expanded]="transfersDropdown.isOpen()" id="bb-menu-header-button-1" role="button">
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@transfers.nav.item.description">Transfers</span>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="transfersDropdown.isOpen() ? 'toggle-up' : 'toggle-down'"></bb-icon-ui>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"></bb-icon-ui>
    </a>
    <div *ngIf="transfersDropdown.isOpen()" @dropdownFadeSlide ngbDropdownMenu class="bb-layout__horizontal-nav-submenu"
      role="region" tabindex="-1" aria-labelledby="bb-menu-header-button-1">

      <button class="bb-layout__horizontal-nav-submenu-header" (click)="transfersDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>
      <ul class="bb-layout__horizontal-nav-column" @menuItemsStagger>
        <li *bbIfEntitlements="permissions.canViewMakeTransfer" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/transfers/make-a-transfer" #makeTransferRouterLink="routerLinkActive"
            [attr.aria-current]="makeTransferRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@make.transfer.nav.submenu.title">
                Own Account Transfers
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewTransferToMember" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/transfers/internal-payments" #moneyToMemberRouterLink="routerLinkActive"
            [attr.aria-current]="moneyToMemberRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@send.mony.nav.submenu.title">
                Internal Payments
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewMakeTransfer" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/transfers/local-payments" #makeTransferRouterLink="routerLinkActive"
            [attr.aria-current]="makeTransferRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@local-payments.nav.submenu.title">
                Local Payments
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewMakeTransfer" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/transfers/mobile-payments" #makeTransferRouterLink="routerLinkActive"
            [attr.aria-current]="makeTransferRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@mpesa.nav.submenu.title">
                Mobile Payments
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewMakeTransfer" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/transfers/international-payments" #makeTransferRouterLink="routerLinkActive"
            [attr.aria-current]="makeTransferRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                International Payments
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewMakeTransfer" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/transfers/airtime-topup"
            #makeTransferRouterLink="routerLinkActive"
            [attr.aria-current]="makeTransferRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@airtime-topup.nav.submenu.title">
                Airtime Top-up
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewScheduledTransfers" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/transfers/activity"
            #scheduledTransfersRouterLink="routerLinkActive"
            [attr.aria-current]="scheduledTransfersRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@activity.nav.submenu.title">
                Scheduled Transfers
              </div>
            </div>
          </a>
        </li>
        <!-- Not Used for SBK -->
        <!-- <li *bbIfEntitlements="permissions.canViewTransferToSomeone">
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/transfers/money-to-someone"
            #moneyToSomeoneRouterLink="routerLinkActive"
            [attr.aria-current]="moneyToSomeoneRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@send.money-to-someone.nav.submenu.title">
                Send Money to Someone
              </div>
            </div>
          </a>
        </li> -->
        <!-- <li *bbIfEntitlements="permissions.canViewConnectedAccounts">
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/transfers/connected-accounts"
            #connectedAccountsRouterLink="routerLinkActive"
            [attr.aria-current]="connectedAccountsRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@connected.accounts.nav.submenu.title">
                Connected Accounts
              </div>
            </div>
          </a>
        </li> -->
      </ul>
    </div>
  </li>
  <!-- Custom bill pay -->

  <li class="bb-layout__horizontal-nav-item" *bbIfEntitlements="permissions.canViewMakeTransfer">
    <a class="bb-layout__horizontal-nav-link link-item" routerLink="/bill-payments"
      routerLinkActive="bb-layout__horizontal-nav-link--active-item" #billPaymentsRouterLink="routerLinkActive"
      [attr.aria-current]="billPaymentsRouterLink.isActive ? 'page' : undefined" role="link">
      <span class="bb-layout__horizontal-nav-item-description">
        Bill Payments
      </span>
    </a>
  </li>

  <!-- Loans -->
  <li class="bb-layout__horizontal-nav-item" *bbIfEntitlements="permissions.canViewMakeTransfer">
    <a class="bb-layout__horizontal-nav-link link-item" routerLink="/loans"
      routerLinkActive="bb-layout__horizontal-nav-link--active-item" #loansRouterLink="routerLinkActive"
      [attr.aria-current]="loansRouterLink.isActive ? 'page' : undefined" role="link">
      <span class="bb-layout__horizontal-nav-item-description">
        Loans
      </span>
    </a>
  </li>

  <li class="bb-layout__horizontal-nav-item" *bbIfEntitlements="permissions.canViewInsightsDashboard">
    <a class="bb-layout__horizontal-nav-link" routerLink="/insights-dashboard"
      routerLinkActive="bb-layout__horizontal-nav-link--active" ariaCurrentWhenActive="page">
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@insights.nav.item.description"> Insights </span>
    </a>
  </li>

  <!-- Invest -->
  <div class="bb-layout__horizontal-nav-item" ngbDropdown display="static" #investDropdown="ngbDropdown"
    bbLayoutNavDropdown #investNavItem="bbLayoutNavDropdown">
    <a ngbDropdownToggle class="bb-layout__horizontal-nav-link link-item" href="javascript:;" tabindex="0" [ngClass]="{
        'bb-layout__horizontal-nav-link--expanded': investDropdown.isOpen() || investNavItem.isActive
      }" [attr.aria-expanded]="investDropdown.isOpen()" id="bb-menu-header-button-4" role="button">
      <span class="bb-layout__horizontal-nav-item-description">Invest</span>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="investDropdown.isOpen() ? 'toggle-up' : 'toggle-down'"></bb-icon-ui>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"></bb-icon-ui>
    </a>
    <div *ngIf="investDropdown.isOpen()" @dropdownFadeSlide ngbDropdownMenu class="bb-layout__horizontal-nav-submenu"
      role="region" tabindex="-1" aria-labelledby="bb-menu-header-button-4">
      <button class="bb-layout__horizontal-nav-submenu-header" (click)="investDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>
      <ul class="bb-layout__horizontal-nav-column" @menuItemsStagger>
        <li @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/invest/savings-account/open-account/normal" #openSavingsAccountRouterLink="routerLinkActive"
            [attr.aria-current]="openSavingsAccountRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                Open a Savings Account
              </div>
            </div>
          </a>
        </li>

        <li @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/invest/unit-trust"
            #unitTrustRouterLink="routerLinkActive"
            [attr.aria-current]="unitTrustRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                Stanbic Unit Trust Funds
              </div>
            </div>
          </a>
        </li>

        <li @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/invest/treasury"
            #unitTrustRouterLink="routerLinkActive"
            [attr.aria-current]="unitTrustRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                Pay T-bills & Bonds
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Account Services -->
  <!-- <li class="bb-layout__horizontal-nav-item" ngbDropdown display="static" #accountServicesDropdown="ngbDropdown"
    bbLayoutNavDropdown #accountServicesNavItem="bbLayoutNavDropdown">
    <a ngbDropdownToggle class="bb-layout__horizontal-nav-link link-item" href="javascript:;" tabindex="0" [ngClass]="{
      'bb-layout__horizontal-nav-link--expanded': accountServicesDropdown.isOpen() || accountServicesNavItem.isActive
    }" [attr.aria-expanded]="accountServicesDropdown.isOpen()" id="bb-menu-header-button-4" role="button">
      <span class="bb-layout__horizontal-nav-item-description">Account Management</span>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="accountServicesDropdown.isOpen() ? 'toggle-up' : 'toggle-down'"></bb-icon-ui>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"></bb-icon-ui>
    </a>
    <div ngbDropdownMenu class="bb-layout__horizontal-nav-submenu" role="region" tabindex="-1"
      aria-labelledby="bb-menu-header-button-4">
      <button class="bb-layout__horizontal-nav-submenu-header" (click)="accountServicesDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>
      <ul class="bb-layout__horizontal-nav-column">
        <li>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/account-services/savings-account" #openSavingsAccountRouterLink="routerLinkActive"
            [attr.aria-current]="openSavingsAccountRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                Open Secondary Account
              </div>
            </div>
          </a>
        </li>

        <div class="nested-submenu">
          <bb-collapsible-accordion-ui>
            <div class="bb-block bb-block--sm">
              <bb-collapsible-card-ui>
                <span bbCollapsibleTitle class="bb-stack">
                  <span class="bb-layout__bb-horizontal-nav-submenu-link font-weight-bold">Account Services</span>
                </span>
                <div bbCollapsibleBody>
                  <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
                    routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
                    routerLink="/account-services/cheques" #detailsRouterLink="routerLinkActive"
                    [attr.aria-current]="detailsRouterLink.isActive ? 'page' : undefined">
                    <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                      <div class="bb-layout__bb-horizontal-nav-submenu-title font-weight-normal">
                        Cards & Cheques
                      </div>
                    </div>
                  </a>

                  <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
                    routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
                    routerLink="/account-services/cheques" #detailsRouterLink="routerLinkActive"
                    [attr.aria-current]="detailsRouterLink.isActive ? 'page' : undefined">
                    <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                      <div class="bb-layout__bb-horizontal-nav-submenu-title font-weight-normal">
                        Standing Order Updates
                      </div>
                    </div>
                  </a>
                </div>
              </bb-collapsible-card-ui>
            </div>
          </bb-collapsible-accordion-ui>
        </div>

      </ul>
    </div>
  </li> -->

  <!-- <li class="bb-layout__horizontal-nav-item" ngbDropdown display="static" #billPayDropdown="ngbDropdown"
    bbLayoutNavDropdown #billPayDropdownState="bbLayoutNavDropdown" *bbIfEntitlements="permissions.canViewBillPay">
    <a ngbDropdownToggle class="bb-layout__horizontal-nav-link" href="javascript:;" tabindex="0" [ngClass]="{
        'bb-layout__horizontal-nav-link--expanded': billPayDropdown.isOpen() || billPayDropdownState.isActive
      }" [attr.aria-expanded]="billPayDropdown.isOpen()" id="bb-menu-header-button-transfers" role="button">
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@bill.pay.nav.item.description">Bill Pay</span>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="billPayDropdown.isOpen() ? 'toggle-up' : 'toggle-down'"></bb-icon-ui>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"></bb-icon-ui>
    </a>
    <div ngbDropdownMenu class="bb-layout__horizontal-nav-submenu" role="region" tabindex="-1"
      aria-labelledby="bb-menu-header-button-transfers">
      <button class="bb-layout__horizontal-nav-submenu-header" (click)="billPayDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>
      <ul class="bb-layout__horizontal-nav-column">
        <li *bbIfEntitlements="permissions.canViewPayABill">
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active" routerLink="/billpay/pay-bills"
            #payBillRouterLink="routerLinkActive" [attr.aria-current]="payBillRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@pay.bill.nav.submenu.title">
                Pay a Bill
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewPendingPayments">
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active" routerLink="/billpay/pending-bills"
            #pendingPaymentsRouterLink="routerLinkActive"
            [attr.aria-current]="pendingPaymentsRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@pending.payments.nav.submenu.title">
                Pending Payments
              </div>
            </div>
          </a>
        </li>
        <li *bbIfEntitlements="permissions.canViewHistoryPayments">
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active" routerLink="/billpay/history-bills"
            #historyPaymentsRouterLink="routerLinkActive"
            [attr.aria-current]="historyPaymentsRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@history.payment.nav.submenu.title">
                History Payments
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </li> -->
  <!-- Analytics: Not being used by SBK -->
  <!-- <li
    class="bb-layout__horizontal-nav-item"
    ngbDropdown
    display="static"
    #analyticsDropdown="ngbDropdown"
    bbLayoutNavDropdown
    #analyticsDropdownState="bbLayoutNavDropdown"
    *bbIfEntitlements="permissions.canViewTransactionsAnalytics"
  >
    <a
      ngbDropdownToggle
      class="bb-layout__horizontal-nav-link"
      href="javascript:;"
      tabindex="0"
      [ngClass]="{
        'bb-layout__horizontal-nav-link--expanded': analyticsDropdown.isOpen() || analyticsDropdownState.isActive
      }"
      [attr.aria-expanded]="analyticsDropdown.isOpen()"
      id="bb-menu-header-button-3"
      role="button"
    >
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@analytics.nav.item.description">Analytics</span>
      <bb-icon-ui
        class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="analyticsDropdown.isOpen() ? 'toggle-up' : 'toggle-down'"
      ></bb-icon-ui>
      <bb-icon-ui
        class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"
      ></bb-icon-ui>
    </a>
    <div
      ngbDropdownMenu
      class="bb-layout__horizontal-nav-submenu"
      role="region"
      tabindex="-1"
      aria-labelledby="bb-menu-header-button-3"
    >
      <button class="bb-layout__horizontal-nav-submenu-header" (click)="analyticsDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>
      <ul class="bb-layout__horizontal-nav-column">
        <li>
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/insights/cashflow"
            #cashFlowRouterLink="routerLinkActive"
            [attr.aria-current]="cashFlowRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@cash.flow.nav.submenu.title">
                Cash Flow
              </div>
            </div>
          </a>
        </li>
        <li>
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/insights/spending-analysis"
            #spendingAnalysisRouterLink="routerLinkActive"
            [attr.aria-current]="spendingAnalysisRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@spending.analysis.nav.submenu.title">
                Spending Analysis
              </div>
            </div>
          </a>
        </li>
        <li>
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/insights/income-analysis"
            #incomeAnalysisRouterLink="routerLinkActive"
            [attr.aria-current]="incomeAnalysisRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@income.analysis.nav.submenu.title">
                Income Analysis
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </li> -->

  <!-- Self service -->
  <div class="bb-layout__horizontal-nav-item" ngbDropdown autoClose="outside" display="static"
    #selfServiceDropdown="ngbDropdown" bbLayoutNavDropdown #selfServiceNavItem="bbLayoutNavDropdown"
    *bbIfEntitlements="permissions.canViewSelfService">

    <a ngbDropdownToggle class="bb-layout__horizontal-nav-link link-item" href="javascript:;" tabindex="0" [ngClass]="{
       'bb-layout__horizontal-nav-link--expanded': selfServiceDropdown.isOpen() || selfServiceNavItem.isActive
     }" [attr.aria-expanded]="selfServiceDropdown.isOpen()" id="bb-menu-header-button-4" role="button">
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@self.service.nav.item.description">
        Self service
      </span>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="selfServiceDropdown.isOpen() ? 'toggle-up' : 'toggle-down'">
      </bb-icon-ui>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right">
      </bb-icon-ui>
    </a>

    <div ngbDropdownMenu class="bb-layout__horizontal-nav-submenu" role="region" tabindex="-1"
      aria-labelledby="bb-menu-header-button-4">

      <button class="bb-layout__horizontal-nav-submenu-header" (click)="selfServiceDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>

      <ul class="bb-layout__horizontal-nav-column" @menuItemsStagger>
        <li *bbIfEntitlements="permissions.canViewMyProfile" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/self-service/profile"
            #myProfileRouterLink="routerLinkActive"
            [attr.aria-current]="myProfileRouterLink.isActive ? 'page' : undefined"
            (click)="selfServiceDropdown.close()">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@profile.nav.submenu.title">
                My Profile
              </div>
            </div>
          </a>
        </li>

        <li *bbIfEntitlements="permissions.canViewManageNotifications" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active" routerLink="/self-service/product-list"
            #manageNotificationsRouterLink="routerLinkActive"
            [attr.aria-current]="manageNotificationsRouterLink.isActive ? 'page' : undefined"
            (click)="selfServiceDropdown.close()">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@manage.notifications.nav.submenu.title">
                Manage Notifications
              </div>
            </div>
          </a>
        </li>

        <ng-container *ngIf="showManageContacts">
          <li *bbIfEntitlements="permissions.canViewManageContacts" @menuItemAnim>
            <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
              routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
              routerLink="/self-service/manage-contacts" #manageContactsRouterLink="routerLinkActive"
              [attr.aria-current]="manageContactsRouterLink.isActive ? 'page' : undefined"
              (click)="selfServiceDropdown.close()">
              <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@manage.contacts.nav.submenu.title">
                  Beneficiary Manager
                </div>
              </div>
            </a>
          </li>
        </ng-container>

        <li *bbIfEntitlements="permissions.canViewAccountStatements" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/self-service/download-statements" #downloadStatementsRouterLink="routerLinkActive"
            [attr.aria-current]="downloadStatementsRouterLink.isActive ? 'page' : undefined"
            (click)="selfServiceDropdown.close()">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title" i18n="@@download.statements.nav.submenu.title">
                Account Statements
              </div>
            </div>
          </a>
        </li>

        <li @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
            routerLink="/invest/secondary-account/open-account" #openSecondaryAccountRouterLink="routerLinkActive"
            [attr.aria-current]="openSecondaryAccountRouterLink.isActive ? 'page' : undefined"
            (click)="selfServiceDropdown.close()">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                Open Secondary Account
              </div>
            </div>
          </a>
        </li>

        <li *bbIfEntitlements="permissions.canViewManageCards" @menuItemAnim>
          <div class="nested-submenu">
            <bb-collapsible-accordion-ui>
              <div class="bb-block bb-block--sm">
                <bb-collapsible-card-ui>
                  <span bbCollapsibleTitle class="bb-stack">
                    <span class="bb-layout__bb-horizontal-nav-submenu-link font-weight-bold"
                      i18n="@@cards.nav.submenu.title">Cards</span>
                  </span>
                  <div bbCollapsibleBody>
                    <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
                      [class.bb-layout__horizontal-nav-submenu-link--active-item]="isViewCardDetailsMenuActive()"
                      routerLink="/self-service/cards"
                      [attr.aria-current]="isViewCardDetailsMenuActive() ? 'page' : undefined"
                      (click)="selfServiceDropdown.close()">
                      <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                        <div class="bb-layout__bb-horizontal-nav-submenu-title font-weight-normal"
                          i18n="@@view-card-details.nav.submenu.title">
                          View Card Details
                        </div>
                      </div>
                    </a>

                    <a *ngIf="!applyCreditCardUnavailable()" class="bb-layout__horizontal-nav-submenu-link"
                      ngbDropdownItem routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
                      routerLink="/loans/get-a-loan" #orderCreditCardRouterLink="routerLinkActive"
                      [attr.aria-current]="orderCreditCardRouterLink.isActive ? 'page' : undefined"
                      (click)="selfServiceDropdown.close()">
                      <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                        <div class="bb-layout__bb-horizontal-nav-submenu-title font-weight-normal"
                          i18n="@@order-credit-card.nav.submenu.title">
                          Order Credit Card
                        </div>
                      </div>
                    </a>

                    <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
                      routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
                      routerLink="/bill-payments/payment" #payCreditCardRouterLink="routerLinkActive"
                      [attr.aria-current]="payCreditCardRouterLink.isActive ? 'page' : undefined"
                      (click)="payCreditCard(); selfServiceDropdown.close()">
                      <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                        <div class="bb-layout__bb-horizontal-nav-submenu-title font-weight-normal"
                          i18n="@@pay-credit-card.nav.submenu.title">
                          Pay Credit Card
                        </div>
                      </div>
                    </a>

                    <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
                      routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item"
                      routerLink="/self-service/cards/travel-advisory" #travelAdvisoryRouterLink="routerLinkActive"
                      [attr.aria-current]="travelAdvisoryRouterLink.isActive ? 'page' : undefined"
                      (click)="selfServiceDropdown.close()">
                      <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
                        <div class="bb-layout__bb-horizontal-nav-submenu-title font-weight-normal"
                          i18n="@@travel-advisory.nav.submenu.title">
                          Travel Advisory
                        </div>
                      </div>
                    </a>
                  </div>
                </bb-collapsible-card-ui>
              </div>
            </bb-collapsible-accordion-ui>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- More -->
  <li class="bb-layout__horizontal-nav-item" ngbDropdown display="static" #moreDropdown="ngbDropdown"
    bbLayoutNavDropdown #moreNavItem="bbLayoutNavDropdown">
    <a ngbDropdownToggle class="bb-layout__horizontal-nav-link link-item" href="javascript:;" tabindex="0" [ngClass]="{
      'bb-layout__horizontal-nav-link--expanded': moreDropdown.isOpen() || moreNavItem.isActive
    }" [attr.aria-expanded]="moreDropdown.isOpen()" id="bb-menu-header-button-4" role="button">
      <span class="bb-layout__horizontal-nav-item-description">More</span>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--vertical"
        [name]="moreDropdown.isOpen() ? 'toggle-up' : 'toggle-down'"></bb-icon-ui>
      <bb-icon-ui class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"></bb-icon-ui>
    </a>

    <div *ngIf="moreDropdown.isOpen()" @dropdownFadeSlide ngbDropdownMenu class="bb-layout__horizontal-nav-submenu"
      role="region" tabindex="-1" aria-labelledby="bb-menu-header-button-4">
      <button class="bb-layout__horizontal-nav-submenu-header" (click)="moreDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>

      <ul class="bb-layout__horizontal-nav-column" @menuItemsStagger>
        <li *bbIfEntitlements="permissions.canViewMessages">
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/more/messages"
            #messagesRouterLink="routerLinkActive"
            [attr.aria-current]="messagesRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__horizontal-nav-submenu-item-label">
              <div class="bb-layout__horizontal-nav-submenu-title" i18n="@@messages.nav.submenu.title">Messages</div>
            </div>
          </a>
        </li>

        <li *bbIfEntitlements="permissions.canViewMyProfile" @menuItemAnim>
          <a class="bb-layout__horizontal-nav-submenu-link" ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active-item" routerLink="/more/get-in-touch"
            #getInTouchRouterLink="routerLinkActive"
            [attr.aria-current]="getInTouchRouterLink.isActive ? 'page' : undefined">
            <div class="bb-layout__bb-horizontal-nav-submenu-item-label">
              <div class="bb-layout__bb-horizontal-nav-submenu-title">
                Get in Touch
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </li>

  <!-- <li
    class="bb-layout__horizontal-nav-item bb-layout__horizontal-nav-item--secondary"
    ngbDropdown
    display="static"
    #moreDropdown="ngbDropdown"
    bbLayoutNavDropdown
    #moreDropdownState="bbLayoutNavDropdown"
  >
    <a
      ngbDropdownToggle
      class="bb-layout__horizontal-nav-link"
      href="javascript:;"
      tabindex="0"
      [ngClass]="{ 'bb-layout__horizontal-nav-link--expanded': moreDropdown.isOpen() || moreDropdownState.isActive }"
      [attr.aria-expanded]="moreDropdown.isOpen()"
      id="bb-menu-header-button-5"
      role="button"
    >
      <bb-icon-ui class="bb-layout__horizontal-nav-item-icon" name="ellipsis-h"></bb-icon-ui>
      <span class="bb-layout__horizontal-nav-item-description" i18n="@@more.nav.item.description">More</span>
      <bb-icon-ui
        class="bb-layout__horizontal-nav-expand-marker bb-layout__horizontal-nav-expand-marker--horizontal"
        name="chevron-right"
      ></bb-icon-ui>
    </a>
    <div
      ngbDropdownMenu
      class="bb-layout__horizontal-nav-submenu"
      role="region"
      tabindex="-1"
      aria-labelledby="bb-menu-header-button-5"
    >
      <button class="bb-layout__horizontal-nav-submenu-header" (click)="moreDropdown.close()">
        <bb-icon-ui class="bb-layout__horizontal-nav-submenu--close" name="angle-left" size="lg"></bb-icon-ui>
        <div class="bb-layout__horizontal-nav-submenu--text" i18n="@@main.menu.nav.submenu.text">Main Menu</div>
      </button>
      <ul class="bb-layout__horizontal-nav-column">
        <li *bbIfEntitlements="permissions.canViewBudgets">
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/more/budgets"
            #budgetsRouterLink="routerLinkActive"
            [attr.aria-current]="budgetsRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__horizontal-nav-submenu-item-label">
              <div class="bb-layout__horizontal-nav-submenu-title" i18n="@@budgets.nav.submenu.title">Budgets</div>
            </div>
          </a>
        </li>

        <li *bbIfEntitlements="permissions.canViewRealTimeCommunicationChat">
          <a
            class="bb-layout__horizontal-nav-submenu-link bb-rtc-live-chat-submenu-item"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            (click)="toggleChatWindow()"
            #liveChatRouterLink="routerLinkActive"
            [attr.aria-current]="liveChatRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__horizontal-nav-submenu-item-label">
              <div class="bb-layout__horizontal-nav-submenu-title" i18n="@@live-chat.nav.submenu.title">Live Chat</div>
            </div>
          </a>
        </li>

        <li *bbIfEntitlements="permissions.canViewPlaces">
          <a
            class="bb-layout__horizontal-nav-submenu-link"
            ngbDropdownItem
            routerLinkActive="bb-layout__horizontal-nav-submenu-link--active"
            routerLink="/more/find-us"
            #findBranchesAndATMsRouterLink="routerLinkActive"
            [attr.aria-current]="findBranchesAndATMsRouterLink.isActive ? 'page' : undefined"
          >
            <div class="bb-layout__horizontal-nav-submenu-item-label">
              <div class="bb-layout__horizontal-nav-submenu-title" i18n="@@places.nav.submenu.title">
                Find Branches and ATMs
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </li> -->
</ul>